
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css';
  import moment from 'moment';


  export default defineComponent({
    name: 'FormDateInput',
    components: {
      Field,
      ErrorMessage,
      flatPickr,
      VueDatePicker,
    },
    props: {
      item: Object,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      let currentItem: any = props.item;

      if (!currentItem.hasOwnProperty('date_picker_mode')) {
        currentItem.date_picker_mode = 'Day';
      }

      onMounted(() => {

        if (currentItem.value) {

          if (currentItem.date_picker_mode == 'Day') {
            let date: any = new Date(currentItem.value);
            if (isNaN(date)) {
              currentItem.value = currentItem.value.split('-').reverse().join('-');
            }
          }

          if (currentItem.date_picker_mode == 'Month') {
             if(typeof currentItem.value == "object"){
               return;
             }
            let month = currentItem.value.split('-')[0];
            let year = currentItem.value.split('-')[1];
            if (month && year) {
              currentItem.value = {
                'month': Number(month),
                'year': Number(year),
              };
            }
          }

          if (currentItem.date_picker_mode == 'Year') {
          }
        }
      });

      // currentItem.key = Math.random().toString(16);
      const state = reactive({
        item: currentItem,
      });


      const getAppendDateConfig = (item) => {
        let config: any = {
          enableTime: false,
          enableSeconds: false,
          disableMobile: true,
          dateFormat: 'Y-m-d',
        };
        if (item.initial_date) {
          config['defaultDate'] = item.initial_date;
        }
        if (item.min_date) {
          config['minDate'] = item.min_date;
        }
        if (item.max_date) {
          config['maxDate'] = item.max_date;
        }
        return config;
      };

      const customPosition = () => ({ top: -200, left: 0 });

      return {
        customPosition,
        ...toRefs(state),
        getAppendDateConfig,
        i18n,
        helpers,
      };
    },
  });
